function Contact() {
  return (
    <div className="page-container py-10 sm:py-12">
      <h1 className="page-heading">Contact Us</h1>
      <p className="text-neutral-300">Contact form and details coming soon.</p>
    </div>
  );
}

export default Contact;